<template>
  <div
    style="
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    "
  >
    <v-card
      class="main-card ma-2 pa-3 d-flex align-center"
      elevation="20"
      height="600px"
      max-width="1500"
      width="100%"
    >
      <v-card
        class="pa-3 ml-3 card-info"
        :color="$vuetify.theme.primary || '#00c7ba'"
        width="50%"
        height="90%"
      >
        <v-card-title style="color: #ffffff !important; font-size: 25px">
          Olá {{ user.nm_pessoa }} <br />
        </v-card-title>
        <v-card-text
          height="100%"
          style="
            height: 85%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            color: #ffffff !important;
            margin-bottom: 1rem;
          "
        >
          <div>
            <p style="font-size: 18px">
              {{
                $route.query.apiError === "true"
                  ? msgApiError
                  : msgProposalReject
              }}
            </p>
            <v-btn
              @click="backToHome"
              style="text-transform: none"
              color="#39424e"
              dark
              >Voltar
              <v-icon class="ml-2">mdi-rotate-left</v-icon>
            </v-btn>
          </div>

          <footer style="display: flex; flex-direction: column; gap: 5px">
            <strong class="mb-2" style="font-size: 20px !important"
              >GLOBUS CORRETORA LTDA</strong
            >
            <span style="font-size: 15px !important"
              >Email: <strong>cotacao@globusseguros.com.br</strong></span
            >
            <span style="font-size: 15px !important"
              >Telefone: <strong>(21)3553-9096 / (21)3553-9097</strong></span
            >
            <span style="font-size: 15px !important"
              >Endereço:
              <strong>Rua da Assembleia, 100 - 12º andar</strong></span
            >
          </footer>
        </v-card-text>
      </v-card>
      <div class="svg-image" style="margin: auto">
        <v-img src="../../../assets/warning.svg" width="100%" contain></v-img>
      </div>
    </v-card>
  </div>
</template>

<script>
import ApiService from "../../../services/ApiService";

export default {
  name: "HelloWorld",
  data() {
    return {
      msgProposalReject: `Infelizmente no momento devido a característica do risco, a
              cotação não pode ser realizada através deste sistema. Nossa equipe
              de especialistas entrará em contato. Abaixo você encontrará informações para contato.`,

      user: {},
      msgApiError:
        "Lamentamos o inconveniente ocorrido, mas parece que houve algum problema em nosso sistema. Nossa equipe de especialistas entrará em contato em breve para resolver a situação. Abaixo, você encontrará informações para contato",
      api: new ApiService(),
    };
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.$route.query.apiError === "true") {
      setTimeout(() => {
        this.sendMailToGlobus();
      }, 10000);
    }
  },
  methods: {
    async sendMailToGlobus() {
      const apiErrorDescription = localStorage.getItem("apiErrorDescription");
      const queryInfos = JSON.parse(localStorage.getItem("queryInfos"));
      try {
        await this.api.post("sendMail/errorSystem", {
          user: this.user,
          apiErrorDescription,
          queryInfos,
        });

        localStorage.removeItem("apiErrorDescription");
      } catch (e) {
        //
      }
    },
    backToHome() {
      window.history.back();
    }
  },
};
</script>

<style lang="scss" scoped>
.main-card {
  display: flex;
  background: #ffffff;
  border-radius: 25px !important;
}

.card-info {
  border-radius: 25px !important;
}

.content {
  max-width: 70%;
}

@media (max-width: 960px) {
  .main-card {
    flex-direction: column-reverse;
  }
  .svg-image {
    display: none !important;
  }
  .card-info {
    width: 100% !important;
    margin-right: 15px;
  }
  .content {
    max-width: unset;
  }
}
</style>
